import { render } from "./territory-list.vue?vue&type=template&id=841cfdd2"
import script from "./territory-list.vue?vue&type=script&lang=js"
export * from "./territory-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__